const qualityLead = `Compassion will send
toast notifications to
notify on active patients
becoming ineligible`
const onDuty = `Compassion will send SMS
on new unread messages
and symptom alerts from
active patients. Symptom
alerts will be escalated
to the next level
automatically when off
duty`
const monitoring = `Compassion will send SMS
on new unread messages
and symptom alerts from
active patients during
business hours`
const onCall = `Compassion will send SMS
on new unread messages
and symptom alerts from
active patients outside
business hours`
const concierge = `Compassion will send
toast notifications on
new messages sent to
Narus Team while the
option is on`
const practitionerNotifications = `Compassion will send
SMS on new unread
messages from other
practitioners (after 10
min)`
const igao = `Compassion will send
toast notifications on
new issues and actions
assigned to you`
const trend = 'Show the Trend field on IGAO questionnaires and Care Plan'
const behavioral = 'Behavioral Health'

export default {
  qualityLead,
  onDuty,
  monitoring,
  onCall,
  concierge,
  practitionerNotifications,
  igao,
  trend,
  behavioral
}
